// Real TARTA brand photography — espresso boxes + burnished Basque
// cheesecake on warm cream marble, natural directional light.
export const IMAGES = {
  // 1 — Open box, top-down: lid leaning forward (TARTA wordmark) revealing
  // the deeply caramelized cheesecake. The hero / money shot.
  openBox:
    'https://cdn.magicpatterns.com/uploads/uLBF4B1j2KcnRg4hjZ7Cry/IMG_8706.png',

  // 2 — Closed box, side-on, dramatic window light with botanical shadows.
  // Moody / editorial.
  moodBox:
    'https://cdn.magicpatterns.com/uploads/jht6dPPkv2KfvD2UZPdgSr/IMG_8707.png',

  // 3 — Hand holding the lid up to camera, soft interior bokeh. Intimate / human.
  lidInHand:
    'https://cdn.magicpatterns.com/uploads/fXDdz1SGJUw8wMRFv1u6wF/IMG_8708.png',

  // 4 — Three closed boxes clustered with dappled leaf shadows. Lineup / gifting.
  trio: 'https://cdn.magicpatterns.com/uploads/dGZ6c4no42tKvHfrhGqyWM/IMG_8709.jpg',

  // 5 — Three boxes (one open showing cheesecake) beside a vase of flowers.
  // Lifestyle / tablescape / gifting.
  tablescape:
    'https://cdn.magicpatterns.com/uploads/5nSHuAfKM8t59ytq3tohwp/IMG_8710.png',

  // Original tight cheesecake crop — used ONLY by the opening Unveiling reveal,
  // which the user wants left exactly as it originally was.
  reveal:
    'https://cdn.magicpatterns.com/uploads/1Pvfe4ZmN7XBVTRYPgu2qA/IMG_6714.jpg',

  // Official TARTA wordmark — black lettering on a white background.
  // Rendered as the real logo (see TartaWordmark). On dark surfaces it is
  // inverted to cream/white lettering with the white background dropped out.
  logoWordmark:
    'https://cdn.magicpatterns.com/uploads/jiePTxH7on3XrRL61mSZ8C/6D0F66DE-60F2-4FE8-9D45-9653D7CB4658.png',

  // ── Flavor lineup (top-down open box, one topping marker per flavor) ──
  // Real brand photos, mapped per the visible topping in each shot.
  flavorPistachio:
    'https://cdn.magicpatterns.com/uploads/t7a11YydM3cFGDk3vdgsXq/IMG_8715.png',
  flavorLotus:
    'https://cdn.magicpatterns.com/uploads/oZ3RUFmjZ9KvS7ZLgfRAXb/IMG_8716.png',
  flavorOreo:
    'https://cdn.magicpatterns.com/uploads/b1XhMrdjHw5FwoS5d9xogA/IMG_8705.png',
  flavorChocolate:
    'https://cdn.magicpatterns.com/uploads/vK7pgFEd9By9jp58qwJU7V/IMG_8717.png',
  flavorManchego:
    'https://cdn.magicpatterns.com/uploads/gF58BMCeAhjYtDZvD7NG6R/IMG_8706.png',

  // ── Semantic aliases used across sections ──
  // The cheesecake itself is best shown via the open-box top-down shot.
  cheesecake:
    'https://cdn.magicpatterns.com/uploads/uLBF4B1j2KcnRg4hjZ7Cry/IMG_8706.png',
  box: 'https://cdn.magicpatterns.com/uploads/jht6dPPkv2KfvD2UZPdgSr/IMG_8707.png',
  hero: 'https://cdn.magicpatterns.com/uploads/uLBF4B1j2KcnRg4hjZ7Cry/IMG_8706.png',
  heroFeature:
    'https://cdn.magicpatterns.com/uploads/uLBF4B1j2KcnRg4hjZ7Cry/IMG_8706.png',
  sensory:
    'https://cdn.magicpatterns.com/uploads/fXDdz1SGJUw8wMRFv1u6wF/IMG_8708.png',
  ig1: 'https://cdn.magicpatterns.com/uploads/dGZ6c4no42tKvHfrhGqyWM/IMG_8709.jpg',
  ig2: 'https://cdn.magicpatterns.com/uploads/jht6dPPkv2KfvD2UZPdgSr/IMG_8707.png',
  ig3: 'https://cdn.magicpatterns.com/uploads/5nSHuAfKM8t59ytq3tohwp/IMG_8710.png',
}
